function fillCharacters(s: string, minCharacters: number, padChar: string): string {
  return padChar.repeat(Math.max(0, minCharacters - s.length));
}

function genericLeftPad(s: string | number, minCharacters: number, padChar: string): string {
  const target = s.toString();
  return fillCharacters(target, minCharacters, padChar) + target;
}

function genericRightPad(s: string | number, minCharacters: number, padChar: string): string {
  const target = s.toString();
  return target + fillCharacters(target, minCharacters, padChar);
}

export function zeroPadLeft(s: string | number, minCharacters: number): string {
  return genericLeftPad(s, minCharacters, '0');
}

export function leftPad(s: string | number, minCharacters: number): string {
  return genericLeftPad(s, minCharacters, ' ');
}

export function rightPad(s: string | number, minCharacters: number): string {
  const target = s.toString();
  return genericRightPad(target, minCharacters, ' ');
}
